import { renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inner-content", {leave: $data.leave, horizontal: $props.horizontal}]),
    relative: ""
  }, [
    _createVNode(_Transition, {
      onEnter: $options.onBeforeEnter,
      onBeforeLeave: $options.onBeforeLeave,
      onAfterEnter: $options.onAfterEnter
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          key: $props.active,
          ref: "item",
          class: "item"
        }, [
          _renderSlot(_ctx.$slots, $props.active, {}, undefined, true)
        ])), [
          [_directive_resize, () => !$data.leave && $data.on_resize()]
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["onEnter", "onBeforeLeave", "onAfterEnter"])
  ], 2 /* CLASS */))
}